import React from "react";
import customTheme from "./lib/utils/theme";
import { CSSReset, ThemeProvider } from "@chakra-ui/core";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./lib/utils/ScrollToTop/ScrollToTop";
import App from "./App";

const SiteApp = () => (
  <ThemeProvider theme={customTheme}>
    <CSSReset />
    <React.StrictMode>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </React.StrictMode>
  </ThemeProvider>
);

export default SiteApp;
